import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../shared/appMaterial/app-material.module';
import { LoginPersistenceService } from '../../core/services/loginPersistence.service';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    AppMaterialModule,
    FlexLayoutModule,
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
  providers: [LoginPersistenceService],
})
export class LoginModule {}
